'use client';

import { faCalendarDays } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { EntityScheduleRedirectButton } from '@/app/(main)/(pages)/_components/entities/entity-schedule-redirect-button.component';
import { Button } from '@/components/ui/button/button.component';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface BranchLaboratoryExamsActionProps {
  laboratoryId: string;
  usesLegacyRedirect: boolean;
  showsSchedules?: boolean;
  onSelectExams: () => void;
  onSeeSchedules: () => void;
}

const actionStyle = 'flex-1 min-w-0 text-base py-2';

export function BranchLaboratoryExamsAction({
  laboratoryId,
  usesLegacyRedirect,
  showsSchedules = false,
  onSelectExams,
  onSeeSchedules,
}: BranchLaboratoryExamsActionProps) {
  if (usesLegacyRedirect) {
    return (
      <EntityScheduleRedirectButton
        path={`/laboratorio/${laboratoryId}/`}
        label="Exames e horários"
        dataTestId={DataTestIdEnum.BRANCH_LABORATORY_PROFILE_SCHEDULE_BUTTON_HEADER}
        analyticsEvent={AnalyticsEnum.LABORATORY_PROFILE_SELECT_REDIRECT_EXAMS_AND_SCHEDULES}
        className={actionStyle}
      />
    );
  }

  if (showsSchedules) {
    return (
      <Button
        startIcon={faCalendarDays}
        startIconSize="1x"
        startIconClassName="w-4 h-4 text-base"
        className={actionStyle}
        data-testid={DataTestIdEnum.BRANCH_LABORATORY_HEADER_SCHEDULES_BUTTON}
        data-analytics-event={AnalyticsEnum.LABORATORY_PROFILE_CLICK_SEE_SCHEDULES}
        onClick={onSeeSchedules}
      >
        Ver horários
      </Button>
    );
  }

  return (
    <Button
      startIcon={faCalendarDays}
      startIconSize="1x"
      startIconClassName="w-4 h-4 text-base"
      className={actionStyle}
      data-testid={DataTestIdEnum.BRANCH_LABORATORY_SELECT_EXAMS_BUTTON}
      data-analytics-event={AnalyticsEnum.LABORATORY_PROFILE_CLICK_SEE_EXAMS}
      onClick={onSelectExams}
    >
      Ver exames
    </Button>
  );
}
